type Env = 'LIVE' | 'DEV'
let env: Env = 'LIVE'

// The public key for ReCaptcha
export const RECAPTCHA_SITE_KEY = env as Env == 'DEV' ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : '6Lc5AuAaAAAAAICuNxDND80M0RvmscXYorxhwdLd'
